export const STATUS_OPTIONS = [
  "New",
  "Bought",
  "Inactive",
  "Active",
  "Active but Closed",
  "Redirected",
  "Expired",
  "Blocked (Abuse)",
  "Blocked (other issue)",
  "Check",
  "Parked",
  "Not Available",
  "Not Verified",
  "In registration process",
  "Registration failed",
  "Verification issues",
  "Verification in process",
  "Re-reg",
  "Re-reg - in registration process",
  "Expired - Not Renewed",
];

export const SITE_TYPE_OPTIONS = [
  "Brand",
  "Slot",
  "Payment",
  "Review",
  "Info",
  "301 Redirect",
  "Apps",
  "Mirror Links",
  "Review Slots",
  "PBN",
];

export const DOMAIN_TYPE_OPTIONS = ["New", "Drop"];

export const CMS_OPTIONS = [
  "Jetsik",
  "WP",
  "Wordpress",
  "HTML",
  "Publii",
  "Jetsik/HTML",
];

export const BRAND_TYPE_OPTIONS = ["New", "Old"];

export const OFFER_OPTIONS = ["Brand", "Cross", "All"];
